import {
  CanActivate,
  RouterStateSnapshot,
  Router,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { AuthenticationService } from 'beyond-util';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private _authService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (!this._authService.isAuthenticated()) {
      this.router.navigate(['login']);

      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts